export class PersonRole {
  id!: number;
  personId!: string;
}
